export function totalNumValidate(value, context, bool) {
  let result = value;
  if (Number(value)) {
    const valueStr = String(parseInt(value));
    const dicStr = String(value).split(".")[1]
      ? String(value).split(".")[1]
      : "00";
    if (valueStr.length > 5 || Number(value) > 99999) {
      context.$toast("输入值过大，请重新输入");
      result = 0;
    } else {
      if (dicStr.length > 2) {
        context.$toast("最多支持两位小数");
        result = String(value).split(".")[0] + "." + dicStr.substr(0, 2);
      }
    }
  } else {
    if (bool) {
      result = 0;
      context.$toast("请输入大于0的数值");
    } else {
      result = 0;
    }
  }

  return result;
}

export function CustomDownPaymentNum(value) {
  let data = "";
  if (value.includes(".")) {
    let arr = value.split(".");
    if (arr[1].length > 2) {
      console.log("ddddd");
      data = Number(value).toFixed(2);
    } else {
      data = value;
    }
  } else {
    data = value;
  }
  return data;
}
